const ITEMS = [
  "Government Contracting",
  "Securing Large Awards",
  "Connecting Businesses",
  "Federal Opportunities",
];

export const Marquee = () => {
  return (
    <section
      data-testid="marquee-section"
      className="relative overflow-hidden border-y border-gold/20 bg-eggshell-800 py-8"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {[...ITEMS, ...ITEMS, ...ITEMS, ...ITEMS].map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="text-outline px-8 font-display text-4xl uppercase tracking-widest md:text-6xl">
              {t}
            </span>
            <span className="h-2 w-2 rotate-45 bg-gold/60" />
          </span>
        ))}
      </div>
    </section>
  );
};
